export default "__VITE_ASSET__EZPyPbY3__"